import { Link } from 'gatsby';
import React, { useEffect, useRef, useState, useContext } from 'react';
import { StoreContext } from '../../context/store-context';
import { priceFormatter } from '../../utils/helpers';
import Image from '../image';

// TODO: When adding bundle to cart, apply and show discount as well
const FrequentlyBoughtWith = ({ products, parentProd }) => {
  const { checkout, addVariantsToCart } = useContext(StoreContext);
  const itemsList = useRef(null);
  const [addingToCart, setAddingToCart] = useState(false);

  // Sorting products so current product is first
  // Then filtering products so unavailable ones are excluded
  const bundleProducts = products
    .sort((a, b) => {
      return a.handle === parentProd.handle ? -1 : 1;
    })
    .filter(product => {
      const availMap = product.variants.map(variant => variant.availableForSale);
      if(availMap.filter(a => a).length > 0) {
        return product;
      }
      return false;
    })

  const [currentVariants, setCurrentVariants] = useState(
    bundleProducts.map(prod => prod.variants[0])
  );
  const [itemPrices, setItemPrices] = useState(
    bundleProducts.map(prod => prod.variants[0].price)
  );

  const savePercent = 10;

  // Getting combined prices of all products in bundle
  const bundlePriceOriginal = currentVariants
    ?.map(variant => variant.price)
    .reduce((partialsSum, a) => partialsSum + a, 0) || 0;
  const bundlePriceDiscount = (bundlePriceOriginal * (100 - savePercent)) / 100

  // Reads selected products and variants from list, updates state
  const updateSelectedItems = () => {
    if(!itemsList.current) { return false; }

    const newItemPrices = []
    const newSelectedVariantIds = []
    const newSelectedVariants = [];

    // First, get all the selected variant IDs
    Array.from(itemsList.current.childNodes).forEach(li => {
      if(!li.querySelector('.Checkbox input').checked) { return false; }
      newSelectedVariantIds.push(li.querySelector('select').value)
    })

    // Iterate all the bundle's products to get variant data based on found IDs
    bundleProducts.forEach((product, index) => {
      const matchingVariant = product.variants.find(variant => {
        return newSelectedVariantIds.includes(variant.legacyResourceId)
      })

      // We need to preserve the frontend price somehow...
      newItemPrices.push(
        matchingVariant?.price ||
        // If a matching variant isn't found, just read the price that is already on the frontend
        parseFloat(
          Array.from(itemsList.current.querySelectorAll('.Freqboughtwith__item__price'))[index]
            .textContent.replace('$', '')
        )
      );

      if(matchingVariant) {
        newSelectedVariants.push(matchingVariant)
      }
    })

    // Update the states
    setCurrentVariants(newSelectedVariants);
    setItemPrices(newItemPrices);
  }

  useEffect(() => {
    updateSelectedItems();
    // Ignoring missing dependency because it creates infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const addItemsToCart = () => {
    setAddingToCart(true);
    addVariantsToCart(currentVariants.map(variant => variant.storefrontId))
  }

  useEffect(() => {
    setAddingToCart(false);
  }, [checkout])

  return (
    <section className="Freqboughtwith">
      <div className="Freqboughtwith__inner">
        <h2 className="Freqboughtwith__title">
          Frequently Bought With
        </h2>

        <div className="Freqboughtwith__main">
          <div className="Freqboughtwith__products">
            {bundleProducts.map((product, index) => (
              <Link
                to={`/product/${product.handle}`}
                className={`Freqboughtwith__product${product.handle === parentProd.handle ? ' currentprod' : ''}`}
                key={index}
              >
                <Image
                  source={product.featuredImage}
                  imgClass="Freqboughtwith__product__image"
                />
              </Link>
            ))}
          </div>
          <div className="Freqboughtwith__info">
            <h3 className="Freqboughtwith__info__title">Total Price:</h3>
            <div className="Freqboughtwith__price">
              <div className="Freqboughtwith__price__discount">
                <sup>$</sup>{priceFormatter(currentVariants.length === products.length ? bundlePriceDiscount : bundlePriceOriginal).replace('$', '')}
              </div>
              {currentVariants.length === products.length && (
                <del className="Freqboughtwith__price__original">
                  <sup>$</sup>{priceFormatter(bundlePriceOriginal).replace('$', '')}
                </del>
              )}
            </div>
            <button
              className="Button Button__secondary"
              disabled={addingToCart || currentVariants.length < 1}
              onClick={addItemsToCart}
            >
              Bundle &amp; Save {savePercent}%
            </button>
          </div>
        </div>

        <ul className="Freqboughtwith__items" ref={itemsList}>
          {bundleProducts.map((product, index) => (
            <li
              className={`Freqboughtwith__item${product.handle === parentProd.handle ? ' currentprod' : ''}`}
              key={index}
            >
              <label htmlFor={product.legacyResourceId} className="Checkbox">
                <input
                  type="checkbox"
                  defaultChecked={true}
                  name={product.legacyResourceId}
                  id={product.legacyResourceId}
                  onChange={updateSelectedItems}
                  className="Freqboughtwith__item__checkbox Checkbox"
                />
                <span>
                  {product.handle === parentProd.handle && (
                    <strong>This product:</strong>
                  )}
                  {product.title}
                </span>
              </label>
              <label
                htmlFor={`${product.legacyResourceId}_variant`}
                className="VisuallyHidden"
              >
                Choose variant:
              </label>
              <select
                className="Freqboughtwith__item__variants"
                name={`${product.legacyResourceId}_variant`}
                id={`${product.legacyResourceId}_variant`}
                onChange={updateSelectedItems}
                // If there is only 1 variant (i.e. nothing to select), just hide this selector
                style={{
                  display: product.variants
                    .filter(variant => variant.availableForSale)
                    .length < 2 ? 'none' : ''
                }}
              >
                {product.variants
                  .filter(variant => variant.availableForSale)
                  .map((variant, index) => (
                    <option value={variant.legacyResourceId} key={index}>
                      {variant.title}
                    </option>
                ))}
              </select>
              <div className="Freqboughtwith__item__price">
                {priceFormatter(itemPrices[index])}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default FrequentlyBoughtWith;
